export const REGISTER_USER = 'register_user';
export const EMPTY_REGISTER_USER = 'EMPTY_REGISTER_USER';
export const SET_REGISTER_USER = 'SET_REGISTER_USER';
export const REGISTER_USER_SUCCESSFUL = 'register_user_successfull';
export const REGISTER_USER_FAILED = 'register_user_failed';



